export const TAGS = (t) => [
    { id: 'overall_performance', label: t('search.comparison.tabs.overall') },
    { id: 'geo_performance', label: t('search.comparison.tabs.geo') },
    { id: 'search_appearance_performance', label: t('search.comparison.tabs.searchAppearance') },
    {
        id: 'keyword_clusters',
        label: t('search.comparison.tabs.keywordClusters'),
        filter: 'decline',
    },
    { id: 'urls', label: t('search.comparison.tabs.urls'), filter: 'decline' },
    { id: 'directories', label: t('search.comparison.tabs.directories'), filter: 'decline' },
    { id: 'ctr', label: t('search.comparison.tabs.ctr') },
];
